// extracted by mini-css-extract-plugin
export var currencyInput = "_jm-1";
export var currencySymbol = "_jm-0";